import { FormlyFieldConfig } from '@ngx-formly/core';
import { isDisplayOnlyFieldType } from '../display-only-field-types';

/** Handoff #20830: locked fields explain themselves instead of silently ignoring input. */
export const LOCKED_FIELD_TITLE = 'Dit veld kan niet worden bewerkt';

/**
 * Supplies the generic hover-tooltip wrapper with a locked explanation.
 * Explicit hover help remains authoritative and readonly fields stay interactive.
 *
 * Display-only field types (`isDisplayOnlyFieldType`, form builder group "Opmaak formulier")
 * never take input, so a "cannot be edited" explanation would mislead rather than help. This used
 * to be a hand-copied list here and quietly missed `readonly-input` and `interface-action-button`
 * — deriving it keeps the two catalogues from drifting apart again.
 */
export function lockedFieldExtension(field: FormlyFieldConfig): void {
  if (!field.props || field.fieldGroup || field.key === undefined || field.key === null) {
    return;
  }

  if (isDisplayOnlyFieldType(typeof field.type === 'string' ? field.type : undefined)) {
    return;
  }

  const tooltipExpression = 'props.hoverTooltip';
  const nativeTitle = field.props.attributes?.['title'];
  if (field.props.hoverTooltip !== undefined || field.expressions?.[tooltipExpression] || nativeTitle !== undefined) {
    return;
  }

  field.expressions = {
    ...field.expressions,
    [tooltipExpression]: () =>
      field.props?.disabled || field.formControl?.disabled ? LOCKED_FIELD_TITLE : undefined,
  };
}
